<!--
 * @Author: your name
 * @Date: 2021-10-20 10:05:28
 * @LastEditTime: 2023-03-11 16:39:31
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\common\lineDo.vue
-->
<template>
  <div>
    <loginTip :closeText='"狠心放弃"' :messageText='""' :okText='"立即领取"' :show="checkLogin"
      :tipstr="'成为星妈，立刻尊享免费问诊权益哟～(๑•ᴗ•๑)♡'" @cancleWay="cancleWay" @confirmWay="confirmWay"></loginTip>
    <div v-if="doctorTextToast" class="doctorToast">
      <div class="wrap">
        <div class="text"> “亲，以下问诊服务由春雨医生为您提供，问诊回答属于建议性内容，如需治疗，请到线下医院就诊哦！
          问诊若有任何问题，将由春雨医生为您全权负责，请放心~”同时提示您注意隐私信息，并关注春雨医生的隐私政策。
        </div>
        <div class="button" @click="confirmWay1">已知晓</div>
      </div>
    </div>
  </div>
</template>

<script>
import { addCookie, getCookie, globalGoLogin, is_weixin, globalGocustomize, getUrlParamsByName } from "@/assets/js/common.js";
import loginTip from "@/views/contents/calendar/component/logintip"; //注册提示组件
import API from "../../utils/axiosApi/aibenApi";
import { getUserInfo } from "../../assets/js/common";
import wx from 'weixin-js-sdk'


export default {
  name: "lineDoctor",
  data() {
    return {
      checkLogin: false,
      utm_campaign: this.$route.query.utm_campaign, // 前向来源
      toUrlSource: this.$route.query.toUrlSource, // 去往哪个链接
      type: this.$route.query.type || '', // 小程序类型
      toUrl: '',
      targetApp: '',  // 小程序跳转链接
      doctorTextToast: false,
      userInfo: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log(from, getCookie("xmh_openid"), '&&&&&&&&&&&&&')
    next(vm => {
      if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {
        sessionStorage.setItem('get_xmh_openid', true)
        //判断有没有授权
        location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
      } else {
        let UserOpenid = getCookie('xmh_openid');
        vm.$http.post('/starMom/getUser', {}, { openId: UserOpenid }, (res) => {
          if (res.code === '200') {
            vm.getUrlLink()
            vm.userInfo = res.data;
            localStorage.setItem('userInfo', JSON.stringify(vm.userInfo)); // 用户信息存储到localStorage中
            vm.getDoctorTextToast()
          } else {
            if (getUrlParamsByName('fromLogin')) {
              if (window.history.length > 1) {
                history.back();
              } else {
                setTimeout('WeixinJSBridge.call("closeWindow")', 50);
              }
            } else {
              vm.checkLogin = true
            }
          }
        }, (error)=>{}, 'member');
      }
    })
  },
  mounted() {
  },
  components: {
    loginTip
  },
  methods: {
    init() {
      this.$http.get(
        '/wechat/oauth2/getJSSDKConfig?url=' +
        encodeURIComponent(location.href.split('#')[0]),
        {},
        (res) => {
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: ['onMenuShareTimeline'], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          })
          wx.ready(function () {
            console.log('ready')
          })
          wx.error(function (res) {
            console.log('err', res)
          })
        }
      )
    },
    getUrlLink() {
      this.init()
      switch (this.toUrlSource) {
        case '1': // 299元诊药安心卡产品
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/product/FEIHE_DRUGQA_A?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/product/FEIHE_DRUGQA_A?utm_campaign='
          break
        case '2': // 99元三甲问诊年卡产品
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/product/FEIHE_3CLASSQA_D?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/product/FEIHE_3CLASSQA_D?utm_campaign='
          break
        case '3': // 儿童用药安全基因检测
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/product/FEIHE_CHILD_GENE?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/product/FEIHE_CHILD_GENE?utm_campaign='
          break
        case '4': // 幽门螺杆菌检测
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/product/FEIHE_SELF_C13?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/product/FEIHE_SELF_C13?utm_campaign='
          break
        case '5': // 菜单栏跳转地址 春雨急速问诊
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/landing-free-consult?utm_campaign=' : "https://momuat.feihe.com" ? 'https://uat-h5.wlbb.net/h5/partner/shining-like-a-start/landing-free-consult?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/landing-free-consult?utm_campaign='
          this.utm_campaign = this.utm_campaign ? this.utm_campaign : 'XMH_H5_GZH_MANU'
          break
        case '6': // 季卡
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/product/FEIHE_3CLASSQA_QUARTERLY?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/product/FEIHE_3CLASSQA_QUARTERLY?utm_campaign='
          break
        case '7': // 月卡
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/product/FEIHE_3CLASSQA_MONTHLY?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/product/FEIHE_3CLASSQA_MONTHLY?utm_campaign='
          break
        case '8': // 菜单栏新增地址
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/list?utm_campaign=' : this.$http.hostName == "https://momuat.feihe.com" ? 'https://uat-h5.wlbb.net/h5/partner/shining-like-a-start/list?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/list?utm_campaign='
          break
        case '9': // 菜单栏新增地址
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/testing/babyBlues?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/list?utm_campaign='
          break;
        case '10': // 春雨健康检测
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/survey/adult?utm_campaign=' : this.$http.hostName == "https://momuat.feihe.com" ? 'https://uat-h5.wlbb.net/h5/partner/shining-like-a-start/survey/adult?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/survey/adult?utm_campaign='
          this.utm_campaign = this.utm_campaign ? this.utm_campaign : 'XMH_H5_GZH_MANU'
          this.targetApp = '/h5/partner/shining-like-a-start/survey/adult?userLevel=';
          break;
        case '11': // 春雨健康检测记录
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/survey/adult/records?utm_campaign=' : this.$http.hostName == "https://momuat.feihe.com" ? 'https://uat-h5.wlbb.net/h5/partner/shining-like-a-start/survey/adult/records?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/survey/adult/records?utm_campaign='
          this.utm_campaign = this.utm_campaign ? this.utm_campaign : 'XMH_H5_GZH_MANU'
          this.targetApp = '/h5/partner/shining-like-a-start/survey/adult/records?userLevel=';
          break;
        default:
          // 春雨急速问诊
          this.toUrl = this.$http.hostName == "https://mom.feihe.com" ? 'https://h5.futurebaobei.com/h5/partner/shining-like-a-start/landing-free-consult?utm_campaign=' : "https://momuat.feihe.com" ? 'https://uat-h5.wlbb.net/h5/partner/shining-like-a-start/landing-free-consult?utm_campaign=' : 'https://test-h5.wlbb.net/h5/partner/shining-like-a-start/landing-free-consult?utm_campaign='
          this.utm_campaign = this.utm_campaign ? this.utm_campaign : 'XMH_H5_GZH_MANU'
          this.targetApp = '/h5/partner/shining-like-a-start/landing-free-consult?userLevel=';
          break
      }
    },
    getSign(crmId) {
      this.$http.get('/baoBeiOpenApi/getSign', { 'crmId': crmId }, (res) => {
        console.log('接口返回了数据')
        if (res.code === '200') {
          const { sign, partnerUserId, timestamp, appId, ueseLevel } = res.data
          const url = this.toUrl + this.utm_campaign + '&sign=' + sign + '&partnerUserId=' + partnerUserId + '&appId=' + appId + '&timestamp=' + timestamp + '&userLevel=' + ueseLevel + '&sysType=CRM'

          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              console.log('小程序环境')
              let envVersion = this.$http.hostName == "https://mom.feihe.com" ? 'release' : 'trial';
              console.log('春雨的小程序路径：' + this.targetApp, this.$route, window.location.href)
              if (this.$route.query.type == 'aiben') {
                wx.miniProgram.redirectTo({
                  url: `/subPackages/other/transfer/index?appId=wx81ecfb5aa3fb512f&path=${encodeURIComponent('/pages/partner/redirect')}&envVersion=${envVersion}&sign=${sign}&timestamp=${timestamp}&appid=${appId}&partnerUserId=${partnerUserId}&targetApp=${encodeURIComponent(this.targetApp + ueseLevel + '&sysType=CRM')}`
                })
              } else {
                wx.miniProgram.navigateBack({})
                wx.miniProgram.postMessage({
                  data: {
                    appId: 'wx81ecfb5aa3fb512f',
                    path: 'pages/partner/redirect',
                    type: 1,
                    envVersion,
                    extraData: {
                      sign,
                      timestamp,
                      appId,
                      partnerUserId,
                      targetApp: this.targetApp + ueseLevel + '&sysType=CRM',
                    }
                  }
                })
              }
            } else {
              window.location.replace(url)
            }
          })
        }
      })
    },
    getDoctorTextToast() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      // 健康检测时，需要判断用户是否定制过，如果没有，则需要跳转到定制
      if(this.toUrlSource == 10) {
        API.isEditAibenMessage({}, { memberId: getUserInfo(), unionId: getCookie('xmh_unionid') }, (res) => {
          if (res.code === 200) {
            if (res.data !== "该用户未定制") {
              this.getSign(this.userInfo.crm_id)
            } else {
              globalGocustomize({fromLoginEdit: true, source: "xmhH5", sySource: this.toUrlSource == 10 ? 'jkjc' : this.toUrlSource == 11 ? 'jkjcjl' : 'jswz', type: this.type })
            }
          } else if(res.code === 205){
            // 非灰度用户，提示，并回退到上一页
            this.$dialog.alert({
              // title: '提示',
              message: '您没有权限访问该页面，请联系管理员添加权限！',
            }).then(() => {
              window.history.back()
            });
          } else {
            this.$toast(res.message)
          }
        })
      }else if (this.toUrlSource != 11 && this.toUrlSource != 10 && !this.getCookie('doctorTextToastFlag')) {
        this.addCookie({ name: "doctorTextToastFlag", data: true })
        this.doctorTextToast = true
      } else {
        this.getSign(this.userInfo.crm_id)
      }
    },
    // 已知晓按钮
    confirmWay1() {
      console.log('点击了按钮')
      this.doctorTextToast = false
      this.getSign(this.userInfo.crm_id)
    },
    confirmWay() {
      this.checkLogin = false
      localStorage.setItem("loginModule", '健康问诊');
      // sySource: jkjc（健康检测）jkjcjl（健康检测记录） jswz（极速问诊）
      globalGoLogin(
        Object.assign(
          {sySource: this.toUrlSource == 10 ? 'jkjc' : this.toUrlSource == 11 ? 'jkjcjl' : 'jswz', type: this.type },
          (this.utm_campaign === 'XMH_H5_SUYUAN' || this.utm_campaign === 'aibenHome') && {source: 'xmhH5'}
        )
      )
    },
    cancleWay() {
      this.checkLogin = false
      wx.miniProgram.getEnv((res) => {
        if (window.history.length > 1) {
          sessionStorage.getItem('get_xmh_openid') ? history.go(-2) : history.back();
          sessionStorage.removeItem('get_xmh_openid')
        } else {
          if (res.miniprogram) {
            wx.miniProgram.navigateBack()
          } else {
            setTimeout('WeixinJSBridge.call("closeWindow")', 50);
          }
        }
      })
    },
    addCookie,
    getCookie,
    is_weixin
  }
}
</script>

<style lang="less" scoped>
.doctorToast {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100vh;
  position: relative;

  .wrap {
    width: 304px;
    // height: 284px;
    background: #FFFFFF;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url('./../../assets/images/icon/remindBg.png');
    background-repeat: no-repeat;
    background-size: 100% 20%;

    .text {
      font-size: 14px;
      color: #333;
      line-height: 22px;
      padding: 64px 19px 0 19px;
      overflow: auto;
      white-space: pre-wrap;
      text-align:center;
    }

    .button {
      width: 152px;
      height: 46px;
      background: #ff67c1;
      border-radius: 100px;
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      line-height: 46px;
      margin: 20px auto;
    }
  }
}
</style>
